import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AUTHENTICATION_ROUTES } from '@aqx-core/common/constants/router';
import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { useSignupCrm } from '@aqx-core/common/services/sign-up-crm';
import { openUrl } from '@aqx-member/web/utils/url/open-url';

import AuthCompletedContent from '../../shared/completed-content';

const SignUpCrmComplete: FCC = () => {
  const { t } = useTranslation();
  const { redirectUrl } = useSignupCrm();
  const navigate = useNavigate();

  const onClickButton = useCallback(() => {
    openUrl(redirectUrl, '_blank');
    navigate(AUTHENTICATION_ROUTES.LOGIN);
  }, [navigate, redirectUrl]);

  return (
    <AuthCompletedContent
      header={t('All done!')}
      description={t(
        "You're all signed up! Complete your KYC to get your account ready for trading. We've also sent you an email with more details."
      )}
      onClickPrimaryButton={onClickButton}
      primaryButtonText={t('Proceed to KYC')}
      primaryButtonDataTestId={EDataTestId.SIGN_UP_COMPLETE_BUTTON}
    />
  );
};

export default SignUpCrmComplete;
